import { createContext } from 'react';

interface JobLockedModalContextValue {
  locked: boolean;
  showModal: (show?: boolean) => void;
}

const Context = createContext<JobLockedModalContextValue>({
  locked: false,
  showModal: () => {},
});

export default Context;
